import { SoySauceIcon } from './SoySauceIcon';

/**
 * author: Colton Wiscombe
 * id 62A5E551-73E0-4C84-89E4-C0F34BDACEFA
 * name soy-sauce
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/soy-sauce.svg
 * tags
 * - Food / Drink 
 */
export const SoyaSauceIcon = SoySauceIcon;
export default SoyaSauceIcon